type type = {
    id: number;
    translationKey: string;
    color:
        | 'default'
        | 'primary'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning';
};

type typesCollection = {
    [key: string]: type;
};

export const typesOfProduct: typesCollection = {
    'REGULAR': {
        id: 1,
        translationKey: 'resources.products.types.regular',
        color: 'success',
    },
    'BUNDLE': {
        id: 2,
        translationKey: 'resources.products.types.bundle',
        color: 'warning',
    },
    'PARENT': {
        id: 3,
        translationKey: 'resources.products.types.variant_parent',
        color: 'primary',
    },
    'CHILD': {
        id: 4,
        translationKey: 'resources.products.types.variant_child',
        color: 'secondary',
    },
};
export const typesNames = {
    '1': 'resources.products.types.regular',
    '2': 'resources.products.types.bundle',
    '3': 'resources.products.types.variant_parent',
    '4': 'resources.products.types.variant_child',
};

export default [
    { id: 1, name: 'resources.products.types.regular' },
    { id: 2, name: 'resources.products.types.bundle' },
    { id: 3, name: 'resources.products.types.variant_parent' },
    { id: 4, name: 'resources.products.types.variant_child' },
];
